import { CarouselDirection } from '~/enums/ui/CarouselDirection'

/** Smoothly scrolls a horizontal carousel one step of `distance` pixels in `direction`. */
export const scrollCarouselStep = (
  container: HTMLElement,
  direction: CarouselDirection,
  distance: number
): void => {
  const offset = direction === CarouselDirection.NEXT ? distance : -distance
  container.scrollTo({ behavior: 'smooth', left: container.scrollLeft + offset })
}
